import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import style from '../admin/exam/ExamResult.module.css'
import axios from 'axios'
import { baseUrl } from '../../baseUrl'

const TWPReviewExam = () => {
  const params = useParams()
  const [review, setReview] = useState([])
  const [exam, setExam] = useState(null)
  const [loading,setLoading]=useState(false)

  const getQuestionNumber = (subject, index, examType) => {
    if (examType === 'topic-wise') {
      return index + 1;
    }
    const sectionRanges = {
      "Physics": { start: 1, end: 45 },
      "Chemistry": { start: 46, end: 90 },
      "Biology": { start: 91, end: 180 },
    };

    const sectionKey = subject;
    const sectionRange = sectionRanges[sectionKey];

    if (sectionRange) {
      return sectionRange.start + index;
    }

    return index + 1; // Fallback
  };

  const filterAndMapQuestions = (subject) => {
    const filteredQuestions = review?.answers?.filter(q => q.subject === subject);
    return filteredQuestions;
  };

  useEffect(() => {
    setLoading(true)
    axios.get(`${baseUrl}/dynamic-exam/get?examId=${params.examId}`)
      .then(res => setExam(res.data))
      .catch(err => console.log(err))
    axios.get(`${baseUrl}/dynamic-exam/twp/review?examId=${params.examId}`)
      .then(res => {setReview(res.data);setLoading(false)})
      .catch(err => {console.log(err);setLoading(false)})
  }, [])

  return (
    <div className='mb-3'>
      <h2 className='text-center mt-2 mb-2'>{
        exam?.type === 'topic-wise' ? 'Topic Wise Practice Exam Review' : 'NEET Flexi Exam Review'
      }</h2>
      {
        loading?
        <div className='container d-flex justify-content-center'>
          <img src="/assets/images/load-time.gif" width='50px' alt="loading"/>
        </div>
        :
        <div className={`${style.instruction} container-lg`}>
        {exam?.type === 'topic-wise' ? (
          // For topic-wise exams, show all questions in one section
          review?.answers?.map((q, i) =>
            <div className=' p-2 m-2'>
              <div className="mb-2"
                dangerouslySetInnerHTML={{
                  __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i, exam?.type)}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                }}
              >
              </div> 
              <div
                className={`mb-2 d-flex ${q.selectedOption !== null ? (q.isCorrect ? 'text-success' : 'text-danger') : 'text-info'}`}
                dangerouslySetInnerHTML={{
                  __html: `
                    <span>Your answer:</span>&nbsp;&nbsp;
                    <span>${q.selectedOption ? q.selectedOption : 'N/A'}</span>
                    `,
                }}
              ></div>
              <div className="mb-2 d-flex"
                dangerouslySetInnerHTML={{
                  __html: `<span>Correct answer:</span>&nbsp;&nbsp;<span>${q.correctAnswer}</span>`,
                }}
              >
              </div>
            </div>
          )
        ) : (
          // For NEET Flexi exams, show questions by subject sections
          <>
            {filterAndMapQuestions("Physics") && filterAndMapQuestions("Physics").length > 0 && (
              <div>
                <h4 className='text-center mb-3'>Physics</h4>
                {filterAndMapQuestions("Physics").map((q, i) =>
                  <div className=' p-2 m-2'>
                    <div className="mb-2"
                      dangerouslySetInnerHTML={{
                        __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i, exam?.type)}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                      }}
                    >
                    </div> 
                    <div
                      className={`mb-2 d-flex ${q.selectedOption !== null ? (q.isCorrect ? 'text-success' : 'text-danger') : 'text-info'}`}
                      dangerouslySetInnerHTML={{
                        __html: `
                          <span>Your answer:</span>&nbsp;&nbsp;
                          <span>${q.selectedOption ? q.selectedOption : 'N/A'}</span>
                          `,
                      }}
                    ></div>
                    <div className="mb-2 d-flex"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Correct answer:</span>&nbsp;&nbsp;<span>${q.correctAnswer}</span>`,
                      }}
                    >
                    </div>
                  </div>
                )}
              </div>
            )}
            {filterAndMapQuestions("Chemistry") && filterAndMapQuestions("Chemistry").length > 0 && (
              <div>
                <h4 className='text-center mb-3'>Chemistry</h4>
                {filterAndMapQuestions("Chemistry").map((q, i) =>
                  <div className=' p-2 m-2'>
                    <div className="mb-2"
                      dangerouslySetInnerHTML={{
                        __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i, exam?.type)}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                      }}
                    >
                    </div> 
                    <div
                      className={`mb-2 d-flex ${q.selectedOption !== null ? (q.isCorrect ? 'text-success' : 'text-danger') : 'text-info'}`}
                      dangerouslySetInnerHTML={{
                        __html: `
                          <span>Your answer:</span>&nbsp;&nbsp;
                          <span>${q.selectedOption ? q.selectedOption : 'N/A'}</span>
                          `,
                      }}
                    ></div>
                    <div className="mb-2 d-flex"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Correct answer:</span>&nbsp;&nbsp;<span>${q.correctAnswer}</span>`,
                      }}
                    >
                    </div>
                  </div>
                )}
              </div>
            )}
            {filterAndMapQuestions("Biology") && filterAndMapQuestions("Biology").length > 0 && (
              <div>
                <h4 className='text-center mb-3'>Biology</h4>
                {filterAndMapQuestions("Biology").map((q, i) =>
                  <div className=' p-2 m-2'>
                    <div className="mb-2"
                      dangerouslySetInnerHTML={{
                        __html: `<span class='mr-2 fw-bold fs-6'>${getQuestionNumber(q.subject, i, exam?.type)}.</span>&nbsp;&nbsp;<span>${q.question}</span>`,
                      }}
                    >
                    </div> 
                    <div
                      className={`mb-2 d-flex ${q.selectedOption !== null ? (q.isCorrect ? 'text-success' : 'text-danger') : 'text-info'}`}
                      dangerouslySetInnerHTML={{
                        __html: `
                          <span>Your answer:</span>&nbsp;&nbsp;
                          <span>${q.selectedOption ? q.selectedOption : 'N/A'}</span>
                          `,
                      }}
                    ></div>
                    <div className="mb-2 d-flex"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Correct answer:</span>&nbsp;&nbsp;<span>${q.correctAnswer}</span>`,
                      }}
                    >
                    </div>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
      }
    </div>
  )
}

export default TWPReviewExam
